export enum PaymentType {
    Credits,
    Money,
    Undefined
}